import Vue from 'vue'
import Vuex from 'vuex'
import Ajax from '../assets/js/Ajax'
import search from './modules/search'
import my_page from './modules/my_page'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user_data: null,
    sukikamo_list: [],
    is_sp: false
  },
  mutations: {
    setUserData (state, data) {
      state.user_data = data;
    },
    setSukikamoList (state, data) {
      state.sukikamo_list = data;
    },
    setIsSp (state, data) {
      state.is_sp = data;
    },
  },
  actions: {
    async init({commit}) {
      const {user_data, sukikamo_list} = await Ajax.getUserData();
      if ( !user_data ) return;

      commit('setUserData', user_data);
      commit('setSukikamoList', sukikamo_list);
    }
  },
  modules: { search, my_page }
});

const mediaQuery = window.matchMedia('(max-width: 639px)');
function checkMediaQuery(mq) { store.commit('setIsSp', mq.matches); }
mediaQuery.addEventListener('change', checkMediaQuery);
checkMediaQuery(mediaQuery);

export default store;
